import styled, { css } from 'styled-components';
import { Body4, Body6, Body7, Headline4 } from '../../typography';

export const HotelSectionContainer = styled.div`
  background: ${({ theme }) => theme.colors.darkBlue};
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.m}
    ${({ theme }) => theme.spacing.m} ${({ theme }) => theme.spacing.m};
`;

export const HotelSectionContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.spacing.xs};
`;

export const HotelSelectionTitleText = styled(Body7)`
  color: ${({ theme }) => theme.colorsInObjects.mint[500]};
`;

export const HotelSelectionSubTitleText = styled(Headline4)`
  color: ${({ theme }) => theme.colors.white};
`;

export const ListSectionContent = styled.div(
  ({ theme, isActive }) => css`
    background-color: ${isActive
      ? theme.colorsInObjects.gray[200]
      : 'transparent'};
    border-bottom: ${isActive
      ? '1px solid ' + theme.colorsInObjects.gray[600]
      : 'none'};
    border-top: ${isActive
      ? '1px solid ' + theme.colorsInObjects.gray[600]
      : 'none'};
    display: flex;
    padding: ${theme.spacing.s} ${theme.spacing.m};
    justify-content: space-between;
    align-items: center;
  `
);

export const ListSectionItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ListSectionContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.s} 0;
  max-height: 210px;
  overflow: scroll;
`;

export const ListBrandName = styled(Body6)(
  ({ theme, isActive }) => css`
    color: ${isActive
      ? theme.colorsInObjects.gray[900]
      : theme.colorsInObjects.gray[800]};
  `
);

export const ListItemName = styled(Body4)(
  ({ theme, isActive }) => css`
    color: ${isActive
      ? theme.colorsInObjects.gray[900]
      : theme.colorsInObjects.gray[800]};
  `
);

export const SearchContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.m};
  margin-top: ${({ theme }) => theme.spacing.l};
`;

export const NoResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};
  align-items: center;
`;
